import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "w-6 text-center",
  viewBox: "0 0 27 25"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  "clip-path": "url(#a)"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M1.962 6.4v16l7-4 8 4 7-4v-16l-7 4-8-4-7 4ZM8.962 2.4v16M16.962 6.4v16" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M.962.4h24v24h-24z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }